module.exports = __webpack_public_path__ + "img/integration.e8a5fb10.png";